import { Host, h } from "@stencil/core";
import { getFormConstraints, toFormField } from "../../utils/FormDefinition";
export class ApieFormGroupDefinition {
    constructor() {
        this.name = undefined;
        this.label = null;
        this.prototyped = false;
        this.status = 'idle';
        this.valueWhenMissing = null;
    }
    getEffectiveValueWhenMissing(fields) {
        if (this.valueWhenMissing) {
            return this.valueWhenMissing;
        }
        const result = {};
        for (let field of fields) {
            result[field.name] = field.valueWhenMissing;
        }
        return result;
    }
    async getDefinition() {
        this.status = 'building';
        const constraints = await getFormConstraints(this.el);
        const fields = await toFormField(this.el.childNodes);
        this.status = 'built';
        return Promise.resolve({
            fieldType: 'group',
            name: this.name,
            label: this.label,
            fields,
            valueWhenMissing: this.getEffectiveValueWhenMissing(fields),
            types: ['group'],
            constraints,
        });
    }
    render() {
        return (h(Host, { key: '7acb6efbde06513d3249645d510618ea96a778f7' }, h("slot", { key: '49071823bdd7c26bd1fdd578c952d4e96171ef50' })));
    }
    static get is() { return "apie-form-group-definition"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-form-group-definition.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-form-group-definition.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string|null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "null"
            },
            "prototyped": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "prototyped",
                "reflect": true,
                "defaultValue": "false"
            },
            "status": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "status",
                "reflect": true,
                "defaultValue": "'idle'"
            },
            "valueWhenMissing": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "value-when-missing",
                "reflect": true,
                "defaultValue": "null"
            }
        };
    }
    static get methods() {
        return {
            "getDefinition": {
                "complexType": {
                    "signature": "() => Promise<FormGroupField>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "FormGroupField": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::FormGroupField"
                        },
                        "FormField": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::FormField"
                        }
                    },
                    "return": "Promise<FormGroupField>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=apie-form-group-definition.js.map
